import { ReactElement } from 'react'
import { useFormikContext } from 'formik'
import { Grid, H, P } from '@farewill/ui'

import { FuneralPlanLeadAttributes } from 'lib/models/lead'
import RadioGroup from 'components/form/radio-group'
import MessageBox from 'components/message-box'
import { useLeadContext } from '../context'

const FORM_FIELDS_NAMES = {
  BUYING_FOR_THEMSELVES: 'purchaserIsCoveredIndividual',
} as const

const Plan = (): ReactElement => {
  const { lead } = useLeadContext()
  const { handleSubmit, setFieldValue } =
    useFormikContext<FuneralPlanLeadAttributes>()

  return (
    <>
      <H size="S">Plans</H>
      <Grid>
        <Grid.Item>
          <RadioGroup
            name={`quoteAttributes.${FORM_FIELDS_NAMES.BUYING_FOR_THEMSELVES}`}
            label="Are they buying the plan for themself?"
            options={[
              { label: 'Yes', value: 'true' },
              {
                label: 'No',
                value: 'false',
              },
            ]}
            handleSave={(data) => {
              if (data.value === 'true') {
                setFieldValue(
                  'quoteAttributes.coveredIndividual.dateOfBirth',
                  undefined
                )
              }

              return handleSubmit()
            }}
          />
        </Grid.Item>
        {lead.attributes.addressValidationWarning ? (
          <Grid.Item>
            <MessageBox warning margin={['S', 0, 'M']}>
              {lead.attributes.addressValidationWarning.map(
                (paragraph, index) => {
                  return <P key={index}>{paragraph}</P>
                }
              )}
            </MessageBox>
          </Grid.Item>
        ) : (
          <></>
        )}
      </Grid>
    </>
  )
}

export default Plan
